if (!customElements.get('journal-book')) {
  customElements.define('journal-book', class JournalBook extends HTMLElement {
    connectedCallback() {
      this.spreads = [...this.querySelectorAll('[data-book-spread]')];
      this.previousButton = this.querySelector('[data-book-previous]');
      this.nextButton = this.querySelector('[data-book-next]');
      this.status = this.querySelector('[data-book-status]');
      this.progress = this.querySelector('[data-book-progress]');
      this.reader = this.querySelector('[data-book-reader]');
      this.openButton = this.querySelector('[data-book-open]');
      this.current = 0;
      this.touchStartX = null;
      this.touchStartY = null;

      this.openButton?.addEventListener('click', () => this.open());
      this.querySelectorAll('[data-book-close]').forEach((button) => {
        button.addEventListener('click', () => this.close());
      });
      this.querySelectorAll('[data-book-page]').forEach((button) => {
        button.addEventListener('click', () => this.show(Number(button.dataset.bookPage)));
      });
      this.previousButton?.addEventListener('click', () => this.show(this.current - 1));
      this.nextButton?.addEventListener('click', () => this.show(this.current + 1));
      this.addEventListener('keydown', (event) => this.onKeydown(event));
      this.addEventListener('touchstart', (event) => {
        this.touchStartX = event.changedTouches[0]?.clientX ?? null;
        this.touchStartY = event.changedTouches[0]?.clientY ?? null;
      }, { passive: true });
      this.addEventListener('touchend', (event) => this.onTouchEnd(event), { passive: true });
      this.render();
    }

    open() {
      this.classList.add('is-open');
      this.reader?.setAttribute('aria-hidden', 'false');
      this.reader?.removeAttribute('inert');
      this.show(0);
      window.setTimeout(() => this.querySelector('[data-book-page], [data-book-next]')?.focus(), 450);
    }

    close() {
      this.classList.remove('is-open');
      this.reader?.setAttribute('aria-hidden', 'true');
      this.reader?.setAttribute('inert', '');
      this.current = 0;
      this.render();
      window.setTimeout(() => this.openButton?.focus(), 350);
    }

    show(index) {
      this.current = Math.max(0, Math.min(index, this.spreads.length - 1));
      this.render();
    }

    render() {
      this.spreads.forEach((spread, index) => {
        spread.classList.toggle('is-active', index === this.current);
        spread.setAttribute('aria-hidden', index === this.current ? 'false' : 'true');
      });
      if (this.previousButton) this.previousButton.disabled = this.current === 0;
      if (this.nextButton) this.nextButton.disabled = this.current === this.spreads.length - 1;
      if (this.status) this.status.textContent = `${this.current + 1} / ${this.spreads.length}`;
      const progress = this.spreads.length ? ((this.current + 1) / this.spreads.length) * 100 : 0;
      this.style.setProperty('--book-progress', `${progress}%`);
      if (this.progress) this.progress.style.width = `${progress}%`;
    }

    onKeydown(event) {
      if (!this.classList.contains('is-open') && (event.key === 'Enter' || event.key === ' ')) {
        if (event.target.closest('[data-book-open]')) {
          event.preventDefault();
          this.open();
        }
        return;
      }
      if (!this.classList.contains('is-open')) return;
      if (event.key === 'ArrowLeft') this.show(this.current - 1);
      if (event.key === 'ArrowRight') this.show(this.current + 1);
      if (event.key === 'Home') this.show(0);
      if (event.key === 'End') this.show(this.spreads.length - 1);
      if (event.key === 'Escape') this.close();
    }

    onTouchEnd(event) {
      if (this.touchStartX === null || !this.classList.contains('is-open')) return;
      const endX = event.changedTouches[0]?.clientX ?? this.touchStartX;
      const endY = event.changedTouches[0]?.clientY ?? this.touchStartY;
      const distance = endX - this.touchStartX;
      const verticalDistance = endY - this.touchStartY;
      this.touchStartX = null;
      this.touchStartY = null;
      if (Math.abs(distance) < 55 || Math.abs(distance) <= Math.abs(verticalDistance)) return;
      this.show(distance < 0 ? this.current + 1 : this.current - 1);
    }
  });
}
